/**
 * Created by Arif Topcu in 2019
 */

import React from "react";
import {
  selectCommittedEntities,
  selectScenarioValue,
} from "state/selections/selector";
import { selectMinInceptionDate } from "state/app/selector";
import { useSelector } from "react-redux";
import { Grid, Cell } from "styled-css-grid";
import styled from "styled-components";
import Mode from "state/selections/Mode";
import { useFormat } from "@ls/js-utils/date-fns";
import SelectionState from "state/selections/SelectionState";

const Label = styled(Cell)`
  color: #e4e4e4;
  font-size: 0.7em;
  justify-self: flex-end;
  align-self: center;
`;
const Value = styled(Cell)`
  color: #e4d995;
  font-size: 0.75em;
  justify-self: flex-start;
  align-self: center;
`;

const CustomValue = styled(Cell)`
  color: #e4d995;
  font-size: 0.75em;
  align-self: center;
  word-wrap: break-word;
`;
const InfoSection = (props) => {
  const selectedEntities = useSelector(selectCommittedEntities);
  const selectedScenarioValue = useSelector(
    selectScenarioValue(SelectionState.COMMITTED)
  );
  const minInceptionDate = useSelector(selectMinInceptionDate);
  const format = useFormat();
  const {
    asOfDateEntity,
    symbolicDate,
    groupTypeEntity,
    displayBenchmarksValue,
    modeEntity,
    lookThru,
  } = selectedEntities;
  return (
    <Grid
      columns={"repeat(4, auto)"}
      rowGap={"0px"}
      columnGap={"4px"}
      rows={"repeat(4, min-content)"}
    >
      <Label>As of Date:</Label>
      <Value>
        {asOfDateEntity ? format(asOfDateEntity, "P") : "..."}
        {symbolicDate ? `(${symbolicDate})` : ""}
      </Value>
      {modeEntity.value === Mode.ACC_GROUPS && (
        <>
          <Label>Group Type:</Label>
          <Value>{groupTypeEntity?.label ?? "..."}</Value>
        </>
      )}

      {/*modeEntity.value !== Mode.SCENARIOS && scenarioEntity?.label && (
        <>
          <Label>Scenario:</Label>
          <Value>{scenarioEntity.label}</Value>
        </>
      )*/}

      <Label>Display Bmk:</Label>
      <Value>{displayBenchmarksValue ? "Yes" : "No"}</Value>
      <Label>Lookthru:</Label>
      <Value>{lookThru ? "Yes" : "No"}</Value>
      {minInceptionDate && (
        <>
          <Label>Inception Date:</Label>
          <Value>{minInceptionDate}</Value>
        </>
      )}
      <Label></Label>
      <Value></Value>
      <Label>Scenario:</Label>
      <CustomValue>{selectedScenarioValue?.join() ?? "..."}</CustomValue>
    </Grid>
  );
};
export default InfoSection;
